
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import { Vue, Component, Watch, Prop, Model } from 'vue-property-decorator';

export enum EnumBizRange {
  洗车 = 1,
  汽车保养 = 2,
  钣金喷漆 = 3,
  轮胎养护 = 4,
  美容装潢 = 5,
  汽车维修 = 6
}
@Component({})
export default class BusinessRangeField extends Vue {
  val: string[] = [];

  checkboxArray: Array<{ key: string; name: string }> = [
    { key: '1', name: '洗车' },
    { key: '2', name: '汽车保养' },
    { key: '3', name: '钣金喷漆' },
    { key: '4', name: '轮胎养护' },
    { key: '5', name: '美容装潢' },
    { key: '6', name: '汽车维修' },
  ];

  mainBizArray: Array<{ id: number; name: string }> = [];

  isReady = false;

  @Prop()
  placeholder?: string;

  @Model('change')
  value!: string[];

  @Watch('value')
  watchValue() {
    if (this.value.length) {
      this.val = this.value;
      this.$emit('updateSubmittable', true);
    } else {
      this.val = [];
      this.$emit('updateSubmittable', false);
    }
    if (!this.isReady) {
      this.isReady = true;
    }
  }

  @lazyInject(ShopService)
  protected shopService!: ShopService;

  onChange(val: string[]) {
    this.val = val;

    this.$emit('change', val);
    if (!this.val.length) {
      this.$emit('updateSubmittable', false);
    } else {
      this.$emit('updateSubmittable', true);
    }
  }

  async getAllMainBusiness() {
    const res = await this.shopService.allMainBusiness();
    if (res && res.length) {
      this.mainBizArray = res;
    }
  }

  async mounted() {
    await this.getAllMainBusiness();
    this.watchValue();
  }
}
